import { UnpluggedIcon, AlertTriangleIcon, RefreshIcon } from "../icons";

/*
 * Generic centered message states. `notfound` (404 / malformed token) and
 * `error` (5xx / network) share the narrower `card-msg` shell; only `error`
 * offers a "Try again" that refetches.
 */
const MessageView = ({ variant, onRetry }) => {
  const isError = variant === "error";
  return (
    <div className="card card-msg card-enter">
      <div className="card-pad msg">
        <div className={`glyph${isError ? " err" : ""}`} aria-hidden="true">
          {isError ? (
            <AlertTriangleIcon size={30} strokeWidth={1.8} />
          ) : (
            <UnpluggedIcon size={30} />
          )}
        </div>
        {isError ? (
          <>
            <h1>Something went wrong</h1>
            <p>
              We couldn&rsquo;t load your download just now. This is almost
              always temporary &mdash; give it another try.
            </p>
            <button type="button" className="btn btn-primary" onClick={onRetry}>
              <RefreshIcon size={18} />
              <span className="lbl">Try again</span>
            </button>
            <p className="support">
              Keeps happening?{" "}
              <a href="mailto:help@movebooth.com">help@movebooth.com</a>
            </p>
          </>
        ) : (
          <>
            <h1>This link isn&rsquo;t valid</h1>
            <p>
              The download link may have been mistyped, or it&rsquo;s no longer
              active. Double-check the link in your email, or open it directly
              from there.
            </p>
            <p className="support">
              Still stuck?{" "}
              <a href="mailto:help@movebooth.com">help@movebooth.com</a>
            </p>
          </>
        )}
      </div>
    </div>
  );
};

export default MessageView;
